// IMPORT
    // MODULE(S)
        import React from 'react';
        import PropTypes from 'prop-types';
        import TextareaAutosize from 'react-textarea-autosize';
    // STYLE(S)
        import '../sass/TodoForm.scss';



// MAIN CONTENT - FUNCTION / COMPONENT
    function TodoForm({ captcha, newTodo, addNewTodo, clearList, deleteList }) {


        // VARIABLE(S)
            let currentKeyDown = [];


        // EVENT(S)
            const onKeyDown = (event) => {
                if (!currentKeyDown.includes(event.keyCode)) {
                    currentKeyDown.push(event.keyCode);

                    if (currentKeyDown.includes(13) && !currentKeyDown.includes(16)) {
                        event.preventDefault();
                        addNewTodo();
                        return false;
                    }
                }
            }
            const onKeyUp = (event) => {
                currentKeyDown.pop(event.keyCode);
            }


        // RETURN
            return (
                <div className="todoForm">
                    <input className="field captcha" type="hidden" ref={captcha} />
                    <div className="addItem">
                        <TextareaAutosize onKeyDown={onKeyDown} onKeyUp={onKeyUp} placeholder="Add a new task ..." ref={newTodo} minRows={1} required pattern=".{1,100}" maxLength="100" />
                        <button className="button add" type="submit" onClick={addNewTodo}>+</button>
                    </div>
                    <div className="removeItem">
                        <button className="button clear" type="submit" onClick={clearList}>Clear list</button>
                        <button className="button delete" type="submit" onClick={deleteList}>Delete list</button>
                    </div>
                </div>
            )
    }
    export default TodoForm;



// PROPTYPES
    TodoForm.propTypes = {
        captcha: PropTypes.object,
        newTodo: PropTypes.object,
        addNewTodo: PropTypes.func,
        clearList: PropTypes.func,
        deleteList: PropTypes.func
    }
